(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[73408],{

/***/ 16581:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("/_next/static/media/image-15-1024x416.97f19f49d5979498de6fd1ce59bedc26.png");

/***/ }),

/***/ 56600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/white-label-marketplace-software",
      function () {
        return __webpack_require__(98158);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_resources";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/api-headless-commerce"
    }), "More about Headless Commerce API")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://github.com/TRADLY-PLATFORM"
    }), "Open source Repositories - iOS, Android, Web App")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://www.youtube.com/playlist?list=PLiKQzSFReAziYUvOKfUPxglX-HOhWabVi"
    }), "Youtube Video series on how to build a marketplace")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://www.youtube.com/watch?v=zLG1hZLxo3o"
    }), "VIDEO: Choosing the right stack and how to approach different solution")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Read: Why it’s ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/white-labeled-plug-and-play-c2c-marketplace-mobile-app-platform"
    }), "better to use pre-built solution like Tradly"))));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 98158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _resources_mdx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39384);
/* harmony import */ var _img_tradly_Low_code_platform_Tradly_1024x268_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13838);
/* harmony import */ var _img_tradly_Developers_lowcode_marketplace_api_1024x314_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21010);
/* harmony import */ var _Shared_TemplatesCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85227);
/* harmony import */ var _partials_Cta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74756);



/* @jsxRuntime classic */ /* @jsx mdx */ 






var Layout = (__webpack_require__(7346)/* .RootFileLayout */ .k);
var meta = {
    "title": "Why Tradly is offering White-label Marketplace Software?",
    "date": "2019-07-10"
};
var slug = "white-label-marketplace-software";
var tableOfContents = [
    {
        "title": "How does it work?",
        "slug": "how-does-it-work",
        "children": []
    },
    {
        "title": "Here is a flow of what you will need to get your app ready to launch.\xa0",
        "slug": "here-is-a-flow-of-what-you-will-need-to-get-your-app-ready-to-launch",
        "children": []
    },
    {
        "title": "Tradly Platform.",
        "slug": "tradly-platform",
        "children": []
    },
    {
        "title": "Video Explanation on how to build your marketplace",
        "slug": "video-explanation-on-how-to-build-your-marketplace",
        "children": []
    },
    {
        "title": "Here’s why Tradly API can help you/your clients",
        "slug": "here-s-why-tradly-api-can-help-you-your-clients",
        "children": []
    },
    {
        "title": "Resources to build, launch and grow marketplaces",
        "slug": "resources-to-build-launch-and-grow-marketplaces",
        "children": []
    }
];
var layoutProps = {
    Layout: Layout,
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = (__webpack_require__(87274)/* .CustomContentsLayout */ .NH);
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Tradly want to bring change in the supply chain of the product/service transaction. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Offer accessibility to every business, whether they are small or big. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Allow transparency for the buyers with hope and confidence. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Making both parties satisfied with their business transaction. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Thus creating a safe and friendly community to help each other.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "aspect-w-16 aspect-h-9"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/N8lVEvAB6kI",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: true
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "how-does-it-work",
        nextElement: {
            "type": "list",
            "ordered": true,
            "start": 1,
            "spread": false
        }
    }, "How does it work?"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/signup"
    }), "Signup for a free account")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Select the ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/templates"
    }), "pre-built templates")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Customise the styling using ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/editor"
    }), "Editor")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Customise your catalogue, user onboarding, Add Payment, Shipment, Service, etc in the ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://superadmin.tradly.app/"
    }), "SuperAdmin")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Web Templates are deployed and you can add your custom domain"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Optional: Mobile Apps pre-built already ready to be launched.")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_Shared_TemplatesCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        category_id: 3865,
        title: " Marketplace Templates",
        isShowBtn: true,
        mdxType: "TemplatesCards"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "here-is-a-flow-of-what-you-will-need-to-get-your-app-ready-to-launch",
        nextElement: {
            "type": "paragraph"
        }
    }, "Here is a flow of what you will need to get your app ready to launch.\xa0"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "For Business users who prefer no code with small changes in design")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: _img_tradly_Low_code_platform_Tradly_1024x268_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
        alt: ""
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("strong", {
        parentName: "p"
    }, "For developers (and their companies) who want a unique design and drastic customization")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: _img_tradly_Developers_lowcode_marketplace_api_1024x314_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
        alt: ""
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "tradly-platform",
        nextElement: {
            "type": "paragraph"
        }
    }, "Tradly Platform."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app"
    }), "TradlyPlatform"), " - Infrastructure as a service.  Tradly have developed a unique set of features that combine social + commerce And have received hundreds of businesses interested in our solutions."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "The infrastructure is built from scratch to accommodate easy customisation through our superadmin panel + the scale of their business, with thoroughly picked up technologies on the backend."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "video-explanation-on-how-to-build-your-marketplace",
        nextElement: {
            "type": "jsx"
        }
    }, "Video Explanation on how to build your marketplace"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-92 h-82 object-cover rounded-lg shadow-lg",
        src: (__webpack_require__(16581)/* ["default"] */ .Z),
        alt: "3. Select the revenue model of your multi-vendor marketplace",
        width: "700"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "aspect-w-16 aspect-h-9"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/T1sN1C9qUSI",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: true
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "here-s-why-tradly-api-can-help-you-your-clients",
        nextElement: {
            "type": "paragraph"
        }
    }, "Here’s why Tradly API can help you/your clients"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "✔ You won’t need to manage servers/db, write business/commerce logics. It’s pre-built."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "✔ Not just fundamental features but also advanced commerce features are available in the SuperAdmin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "✔ Tradly do provide starter Kits for ReactJs, React Native, Flutter, etc"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "✔ You’ll save time by not developing the front end from scratch and still can customise."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "✔ Your platform is future-proof with API first, and scalable solution.", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("br", {
        parentName: "p"
    }), "\n", "✔ You’ll get new product features releases every quarter. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_partials_Cta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        mdxType: "Cta"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "resources-to-build-launch-and-grow-marketplaces",
        nextElement: {
            "type": "jsx"
        }
    }, "Resources to build, launch and grow marketplaces"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_resources_mdx__WEBPACK_IMPORTED_MODULE_4__["default"], {
        mdxType: "Resources"
    }));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 85227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70441);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60538);








var TemplatesCards = function(param) {
    var template_id = param.template_id, category_id = param.category_id, title = param.title, isShowBtn = param.isShowBtn, template_btn_title = param.template_btn_title;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), templates = ref[0], setTemplates = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var params = {
            page: 1
        };
        if (category_id) {
            params.category_id = category_id;
        }
        axios__WEBPACK_IMPORTED_MODULE_1___default().get("/api/all_templates", {
            params: params
        }).then(function(res) {
            setTemplates(res.data.data.listings);
        });
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center my-5 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "h4 m-0 text-black font-semibold",
                        children: (title === null || title === void 0 ? void 0 : title.length) > 0 && title
                    }),
                    isShowBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: {
                            pathname: "/templates"
                        },
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn-sm bg-primary hover:bg-transparent text-white hover:text-primary ",
                            children: "See All"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid gap-12 md:grid-cols-3 md:gap-x-6 md:gap-y-8 items-start",
                children: templates === null || templates === void 0 ? void 0 : templates.map(function(item) {
                    var Type = function(attributes) {
                        var ref, ref1;
                        return (ref1 = (ref = attributes.filter(function(at) {
                            return at.name === "Type";
                        })[0]) === null || ref === void 0 ? void 0 : ref.values[0]) === null || ref1 === void 0 ? void 0 : ref1.name;
                    };
                    // is_active
                    var is_active = function(attributes) {
                        var ref;
                        return ((ref = attributes.filter(function(at) {
                            return at.name === "Active";
                        })[0]) === null || ref === void 0 ? void 0 : ref.values[0]) == true ? true : undefined;
                    };
                    if ((template_id === null || template_id === void 0 ? void 0 : template_id.length) > 0) {
                        if (template_id.includes(item.id) && is_active(item.attributes)) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col h-full sha rounded-md overflow-hidden border border-[#eaeaea] hover:shadow-medium p-3 transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " w-full h-[200px] block relative mb-5 overflow-hidden ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "w-full h-full object-cover object-top ",
                                                    src: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getThumbnailImage)(item.images[0]),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: " px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center",
                                                children: item.title.length > 20 ? item.title.substr(0, 20) + ".." : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/templates/".concat(item.slug),
                                            className: "btn w-full bg-primary hover:bg-white text-white hover:text-primary border border-transparent hover:border-primary transition duration-300 ",
                                            onClick: function() {
                                                var _obj;
                                                (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelEventName.click_template_on_embed */ .aK.click_template_on_embed, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.referrer */ .Oe.referrer, router.pathname), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.template_slug */ .Oe.template_slug, item.slug), _obj));
                                            },
                                            children: template_btn_title ? template_btn_title : "GET TEMPLATE"
                                        })
                                    })
                                ]
                            });
                        }
                    } else {
                        if (is_active(item.attributes)) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col h-full sha rounded-md overflow-hidden border border-[#eaeaea] hover:shadow-medium p-3 transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " w-full h-[200px] block relative mb-5 overflow-hidden ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "w-full h-full object-cover object-top ",
                                                    src: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getThumbnailImage)(item.images[0]),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: " px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center",
                                                children: item.title.length > 20 ? item.title.substr(0, 20) + ".." : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/templates/".concat(item.slug),
                                            className: "btn w-full bg-primary hover:bg-white text-white hover:text-primary border border-transparent hover:border-primary transition duration-300 ",
                                            onClick: function() {
                                                var _obj;
                                                (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelEventName.click_template_on_embed */ .aK.click_template_on_embed, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.referrer */ .Oe.referrer, router.pathname), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.template_slug */ .Oe.template_slug, item.slug), _obj));
                                            },
                                            children: template_btn_title ? template_btn_title : "GET TEMPLATE"
                                        })
                                    })
                                ]
                            });
                        }
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TemplatesCards);


/***/ }),

/***/ 74756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function Cta() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-6xl mx-auto px-4 sm:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-12 md:pb-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative bg-gray-100 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden",
                    "data-aos": "zoom-y-out",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 bottom-0 pointer-events-none hidden lg:block",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                width: "428",
                                height: "328",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                                            cx: "35.542%",
                                            cy: "34.553%",
                                            fx: "35.542%",
                                            fy: "34.553%",
                                            r: "96.031%",
                                            id: "ni-a",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0.25"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                                fill: "#34CDB1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".04",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "16",
                                                        ry: "15.576"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".24",
                                                        cx: "100",
                                                        cy: "68.402",
                                                        rx: "24",
                                                        ry: "23.364"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "29",
                                                        ry: "28.231"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "342",
                                                        cy: "31.303",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".48",
                                                        cx: "62",
                                                        cy: "126.811",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "78",
                                                        cy: "7.072",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "6",
                                                        ry: "5.841"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                fill: "url(#ni-a)",
                                                cx: "276",
                                                cy: "237",
                                                r: "200"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col lg:flex-row justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-6 lg:mr-16 lg:mb-0 text-center lg:text-left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                            className: "h3 text-black mb-2",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                                    children: "Simple and FREE."
                                                }),
                                                " ",
                                                "Launch your project today!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-black text-lg opacity-75",
                                            children: [
                                                "- Launch Marketplaces, Online Storefronts, Booking Apps, Classifieds, Directories, Partner Portals, App Stores, etc.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " - Tradly pricing starts with ZERO. You pay only when you grow.",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " - Free No-code Integrations, No-Code Editor"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "btn whitespace-nowrap bg-primary text-white px-20 ",
                                        href: "/signup",
                                        children: "SIGN UP NOW"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Cta);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,48777,26852,5679,40603,49774,92888,40179], function() { return __webpack_exec__(56600); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);